<template>
    <div class="ranking">
        <div class="tit">
            <img src="@/assets/common/titLogo.png"
                 alt="">
            <span>
                {{
					lotteryType == 0 ? '双色球':
					lotteryType == 1 ? '大乐透':
					lotteryType == 2 ? '福彩3D':
					lotteryType == 3 ? '排列三':''
				}}指标排名
            </span>
        </div>
        <div class="cont" v-loading="loading">
            <div class="nav">
                <span v-for="(item,index) in rankingArr"
                      :key="index"
                      :class="rankingActive == index ? 'active' : ''"
                      @click="rankingActive = index;getRanking()">{{item}}</span>
            </div>

            <!-- 加载中骨架屏 -->
            <div v-if="loading" class="table skeleton">
                <div class="thead">
                    <span>名次</span>
                    <span>缩水师</span>
                    <span>成绩</span>
                    <span>积分</span>
                    <span>升降</span>
                </div>
                <div v-for="i in 5" :key="i" class="tbody skeleton-row">
                    <span><div class="skeleton-block"></div></span>
                    <span><div class="skeleton-block"></div></span>
                    <span><div class="skeleton-block"></div></span>
                    <span><div class="skeleton-block"></div></span>
                    <span><div class="skeleton-block"></div></span>
                </div>
            </div>

            <!-- 加载失败 -->
            <div v-else-if="loadError" class="error-container">
                <div class="error-icon">!</div>
                <div class="error-text">加载失败</div>
                <div class="error-retry" @click="getRanking">点击重试</div>
            </div>

            <!-- 正常数据 -->
            <div v-else class="table">
                <div class="thead">
                    <span>名次</span>
                    <span>缩水师</span>
                    <span>成绩</span>
                    <span>积分</span>
                    <span>升降</span>
                </div>
                <div v-for="(item, index) in db"
                     :key="index"
                     class="tbody">
                    <template v-if="index<=2">
                        <span class="qiansan"
                              v-if="index == 0"> <img src="@/assets/common/rank/1.gif"
                                 alt=""> </span>
                        <span class="qiansan"
                              v-if="index == 1"> <img src="@/assets/common/rank/2.gif"
                                 alt=""></span>
                        <span class="qiansan"
                              v-if="index == 2"> <img src="@/assets/common/rank/3.gif"
                                 alt=""></span>
                    </template>
                    <span v-else>{{ index + 1 }}</span>

                    <span @click="view_history(
						item,
						(
							lotteryType == 0 ? 'ssq':
							lotteryType == 1 ? 'dlt':
							lotteryType == 2 ? 'fcse':
							lotteryType == 3 ? 'pls':''
						)
					)" style="cursor: pointer;color:#4084b4">{{item.nickName}}</span>
                    <span>{{item.achievement}}</span>
                    <span>{{item.totalScore}}</span>
                    <span v-if="item.ifResi == '0'">降</span>
                    <span v-if="item.ifResi == '1'">平</span>
                    <span v-if="item.ifResi == '2'">升</span>
                </div>
                <!-- 空数据 -->
                <div v-if="!loading && db.length === 0" class="empty-row">
                    <span>暂无数据</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { queryPreRankingList } from "@/api/home"
import {} from '@/api/home'
export default {
    props: ['rankingArr', 'lotteryType'],
    data () {
        return {
            rankingActive: 0,
            db: [],
            loading: false,      // 【P0 修复】加载状态
            loadError: false,    // 【P0 修复】错误状态
        };
    },
    watch: {
    },
    mounted () {
        // 【性能优化】错峰加载：随机延迟 0~500ms，避免首页 8 个排行榜同时请求打满后端
        // 配合后端信号量，减少瞬时并发压力
        const delay = Math.floor(Math.random() * 500)
        setTimeout(() => {
            this.getRanking()
        }, delay)
    },
    methods: {
		// 查看历史记录
		view_history (item, preType) {

			this.$router.push({
				path: '/dating_viewHistory',
				query:{
					shrinkId: item.shrinkId || item.createUser,
					number: item.number,
					userName: item.nickName,
					preType,
				}
			})
		},
		// 【P0 修复】指标排名 - 增加加载状态、错误处理、重试机制
        getRanking () {
			let preIndexType = []

			if(['2','3'].includes(this.lotteryType)){
				preIndexType = [5,0,1,2,3,4]
			}else{
				preIndexType = [7,0,1,2,3,4,5,6]
			}

			this.loading = true
			this.loadError = false

            queryPreRankingList({
                preType: this.lotteryType,
                preIndexType: preIndexType[this.rankingActive],
                risingNo: 10,
            }).then(res => {
				// 业务成功（code 200）才赋值
				if (res && (res.code === 200 || res.code === undefined)) {
					this.db = res.data || []
				} else {
					// 业务错误
					this.db = []
					this.loadError = true
				}
            }).catch(err => {
				// 【P0 修复】捕获网络/超时/HTTP 错误
				console.error('排行榜加载失败', err)
				this.db = []
				this.loadError = true
				// 全局错误提示已在 http.js 中统一弹出，这里不再重复
			}).finally(() => {
				this.loading = false
			})
        },
    }
};
</script>

<style lang="scss" scoped>
.ranking {
	height: 100%;
    .tit {
        font-weight: bold;
        margin-bottom: 10px;
        display: flex;
        align-items: center;

        img {
            width: 20px;
        }

        span {
            margin-left: 10px;
        }
    }

    .cont {
		height: calc(100% - 33px);
		position: relative;
        .nav {
            display: flex;
            border-right: 1px solid #8fb3da;

            span {
                cursor: pointer;
                white-space: nowrap;
                font-size: 14px;
                padding: 5px;
                border: 1px solid #8fb3da;
                border-right: 0;
                background-color: #e8e8e8;
                flex: 1;
                text-align: center;

                &.active {
                    background-color: #ffffff;
                    font-weight: bold;
                    border-bottom: 1px solid #ffffff;
                }
            }
        }

        .table {
            border: 1px solid #8fb3da;
            border-top: 0;
            // font-weight: bold;
            padding-top: 10px;
			height: 92%;
            > div {
                display: grid;
                grid-template-columns: 10% 30% 20% 30% 10%;
                grid-auto-flow: column;
                border-bottom: 1px solid rgba(0, 0, 0, 0.07);

                span {
                    text-align: center;
                    padding: 10.8px 0;
					white-space: nowrap;
                }
            }

            .qiansan {
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    width: 13px;
                }
            }
        }

		// 【P0 修复】骨架屏样式
		.skeleton {
			.skeleton-row {
				opacity: 0.6;
			}
			.skeleton-block {
				display: inline-block;
				width: 60%;
				height: 14px;
				background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
				background-size: 200% 100%;
				animation: skeleton-loading 1.5s infinite;
				border-radius: 3px;
				vertical-align: middle;
			}
		}

		@keyframes skeleton-loading {
			0% { background-position: 200% 0; }
			100% { background-position: -200% 0; }
		}

		// 【P0 修复】错误状态样式
		.error-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			height: 80%;
			color: #999;

			.error-icon {
				width: 40px;
				height: 40px;
				line-height: 40px;
				border-radius: 50%;
				background-color: #fef0f0;
				color: #f56c6c;
				font-size: 20px;
				font-weight: bold;
				margin-bottom: 10px;
			}
			.error-text {
				font-size: 14px;
				margin-bottom: 10px;
			}
			.error-retry {
				font-size: 13px;
				color: #409eff;
				cursor: pointer;
				&:hover {
					text-decoration: underline;
				}
			}
		}

		// 空数据样式
		.empty-row {
			display: flex !important;
			justify-content: center !important;
			span {
				width: 100% !important;
				color: #999;
				font-size: 13px;
			}
		}
    }
}

/* ===== 移动端适配 ===== */
@media (max-width: 768px) {
    /* 指标排名 tab 改为 3 列网格（双色球/大乐透/福彩3D/排列三 四个板块共用本组件，一处生效） */
    .ranking {
        .cont {
            .nav {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
            }
        }
    }
}
</style>
